import astex from './astex';

const CLIENTS_BY_NAME = {
  astex
};

const getClientByName = (clientName) => CLIENTS_BY_NAME[clientName];

export default getClientByName;